module.exports = __webpack_public_path__ + "static/img/icon_class_camera.83c3fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_camera.png
// module id = TbcQ
// module chunks = 1